<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-numerictextbox
            [ngClass]="generateInputStyle()"
            [id]="id"
            [title]="title | translate"
            [maxlength]="maxLength"
            [format]="format"
            [min]="min"
            [max]="max"
            [autoCorrect]="true"
            [disabled]="isDisabled"
            [decimals]="decimals"
            [readonly]="isDisabled"
            [spinners]="showSpinners"
            [(ngModel)]="value"
            (valueChange)="onValueChange($event)"
            (inputFocus)="onFocusIn()"
            (inputBlur)="onFocusOut()" />
    } @else {
        <!-- Might want to add tooltipFormat override possibility -->
        <div class="pb-1 pt-1.5" kendoTooltip position="top" [title]="value() | kendoFormat: format">
            {{ value() | kendoFormat: format }}
        </div>
    }
</app-input-label>
